import RadioGroupComponent from './RadioGroupComponent';

export default RadioGroupComponent;
